/**
 * Uma pergunta só: a Central de Conquistas EXISTE para este documento?
 *
 * 07/08 (auditoria prod-vs-main): em produção `gamification.enabled` é false, e
 * o caminho flag-OFF nunca era exercitado. Quem lia só a flag persistida
 * pintava CTA que trocava a URL para `?conquistas=` e não abria nada — o
 * overlay desktop é gated e o mobile não tem superfície. Toda superfície que
 * ofereça um caminho PARA a Central precisa da mesma autoridade que as
 * superfícies da Central usam (`useConquestsMasterLifecycle`): snapshot
 * autoritativo deste documento E flag mestre ligada. Fail-closed — o palpite
 * persistido do localStorage nunca basta.
 */
import {
  useGamificationFlags,
  useGamificationFlagsAuthoritative,
} from "./useGamificationEnabled";

/** True só quando a Central pinta de fato — use para decidir se um CTA que
 * leva até ela deve sequer renderizar.
 * @example `if (!useConquestsCentralReachable()) return null;` */
export function useConquestsCentralReachable(): boolean {
  const flags = useGamificationFlags();
  const authoritative = useGamificationFlagsAuthoritative();
  return authoritative && flags.enabled;
}
